import Vue from 'vue'
import Analytics from './analyticsPlugin.js'
import Features from './featuresPlugin.js'
import LaunchDarkly from './launchDarklyPlugin.js'

Vue.use(Analytics, { debug: process.env.NODE_ENV !== 'production' })
Vue.use(Features)
Vue.use(LaunchDarkly, { debug: process.env.NODE_ENV !== 'production' })
